import React from "react";
import { Table } from "react-bootstrap";
import ReceiptPanelItem from "./receiptpanelitem";
import ReceiptQuickAdd from "./receiptquickadd";


const ReceiptsPanel = ({ fields, setField,lineItemCategories = [], readOnly = false }) => {

    const update = (id, data) => {
        setField(prev => 
            prev.map(item => (item.id === id ? {...item,...data} : item))
        );
    }

    const remove = (id) => {
        setField((prev) => prev.filter(item => item.id !== id));
    }

    const prepend = (obj) => {
        setField([obj, ...fields]);
    }

    const TotalCount = ({ items }) => {
        const total = items.reduce((acc, item) => acc + item.amount, 0).toFixed(2);

        return (
            <>{total}</>
        )
    }

    return (
        <>
            <h6 className="fw-bold text-center">Receipts</h6>
            {
                !readOnly
                ?
                    <ReceiptQuickAdd types={lineItemCategories} add={prepend} />
                :
                    null
            }
            <Table striped hover responsive size="sm">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Detail</th>
                        <th>Amount</th>
                        {
                            !readOnly
                            ?
                                <th style={{ width: '1%' }}>Actions</th>
                            :
                                null
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        fields.length > 0
                            ?
                            fields.map((item) => (
                                <ReceiptPanelItem 
                                 key={item.id} item={item} types={lineItemCategories} 
                                 remove={() => remove(item.id)} update={(obj) => update(item.id, obj)} readOnly={readOnly} />
                            ))
                            :
                            <tr>
                                <td colSpan={readOnly ? 3 : 4} className="text-center">
                                    No Receipts Entered
                                </td>
                            </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan={2}>
                            TOTAL
                        </th>
                        <th colSpan={readOnly ? 1 : 2}>
                            <TotalCount items={fields} />
                        </th>
                    </tr>
                </tfoot>
            </Table>
        </>
    )
}

export default ReceiptsPanel;
